import { render, staticRenderFns } from "./Enfermeria.vue?vue&type=template&id=63a841a8&scoped=true"
import script from "./Enfermeria.vue?vue&type=script&lang=js"
export * from "./Enfermeria.vue?vue&type=script&lang=js"
import style0 from "./Enfermeria.vue?vue&type=style&index=0&id=63a841a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a841a8",
  null
  
)

export default component.exports